module.exports = {"id":"225120","name":"Rachid Aït-Atmane","rating":"71","photo":"./data/images/photos/2/225120.png","club":{"name":"Waasl. Beveren","logo":"./data/images/clubs/Waasl.Beveren.png"},"positions":["MDC","MC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RachidAit-Atmane0.json
// module id = 3492
// module chunks = 0